import React from 'react';
import { Element } from './ProductList.styles';
import CardProduct from '../CardProduct/CardProduct';
import { Text } from '@/components/typography';
import { useTranslations } from 'next-intl';

export interface ProductListProps {
  pacotes: PacoteItineraryType[];
}

const ProductList = ({ pacotes, ...props }: ProductListProps) => {
  const t = useTranslations('Viagem');
  return (
    <Element {...props}>
      {(pacotes.length && pacotes.map((pacote, index) => <CardProduct key={pacote.uuid} pacote={pacote} />)) || (
        <Text>{t('Não há pacotes para este destino no momento')}.</Text>
      )}
    </Element>
  );
};

export default ProductList;
